module.exports = __webpack_public_path__ + "static/media/gate@2x.4a793cee.png";